/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Фильтр для поиска документов обмена валют
 */
export interface CurrencyExchangeFilter {
  /** @format int32 */
  position?: number;

  /** @format int32 */
  size?: number;
  sortField?: string;
  sortDir?: string;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  stateList?: string[];
  docNum?: string;
  orderType?: "BUY_CURRENCY" | "SELL_CURRENCY" | "CONVERSION_CURRENCY";
  amount?: number;
}

/**
 * Возможности клиента
 */
export interface ClientPermissions {
  /** Название возможности */
  name?: string;

  /** Описание возможности */
  desc?: string;

  /** Признак доступности возможности */
  isAvailable?: boolean;
}

/**
 * Элемент пагинированного списка документов обмена валют
 */
export interface CurrencyExchangeEntryResponse {
  /**
   * ID документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  docNum?: string;

  /**
   * Дата создания документа
   * @format date-time
   */
  docDate?: string;

  /** Тип операции */
  orderType?: string;

  /** Номер счёта списания */
  debitAccount?: string;

  /** Сумма списания */
  debitSum?: number;

  /** Буквенный код валюты списания */
  debitCurrency?: string;

  /** Номер счёта зачисления */
  creditAccount?: string;

  /** Сумма зачисления */
  creditSum?: number;

  /** Буквенный код валюты зачисления */
  creditCurrency?: string;

  /** Курс обмена */
  rate?: number;

  /** Заполненная пользователем сумма */
  specifiedSum?: "DEBIT" | "CREDIT";

  /** Статус выполнения документа */
  state?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate?: string;

  /** Список возможностей */
  permissions?: ClientPermissions[];
}

/**
 * Список документов обмена валют
 */
export interface CurrencyExchangeListResponse {
  /** Пагинированный список документов обмена валют */
  currencyExchangeEntries?: PageCurrencyExchangeEntryResponse;

  /**
   * Размер возвращаемого списка документов обмена валют
   * @format int32
   */
  size?: number;
}

/**
 * Пагинированный список документов обмена валют
 */
export interface PageCurrencyExchangeEntryResponse {
  /** @format int32 */
  totalPages?: number;

  /** @format int64 */
  totalElements?: number;

  /** @format int32 */
  size?: number;
  content?: CurrencyExchangeEntryResponse[];

  /** @format int32 */
  number?: number;
  sort?: SortObject;

  /** @format int32 */
  numberOfElements?: number;
  pageable?: PageableObject;
  last?: boolean;
  first?: boolean;
  empty?: boolean;
}

export interface PageableObject {
  /** @format int64 */
  offset?: number;
  sort?: SortObject;

  /** @format int32 */
  pageNumber?: number;

  /** @format int32 */
  pageSize?: number;
  paged?: boolean;
  unpaged?: boolean;
}

export interface SortObject {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Запрос на получение курса обмена валют
 */
export interface GetCurrencyRateRequest {
  /** Тип заявки */
  orderType: "BUY_CURRENCY" | "SELL_CURRENCY" | "CONVERSION_CURRENCY";

  /**
   * ID счёта списания
   * @format uuid
   */
  debitAccountId: string;

  /** Сумма списания */
  debitSum?: number;

  /**
   * ID счёта зачисления
   * @format uuid
   */
  creditAccountId: string;

  /** Сумма зачисления */
  creditSum?: number;

  /** Тип курса операции */
  rateType: "BANK" | "INDIVIDUAL";
}

export interface GetCurrencyRateResponse {
  currencyRate?: number;
  currencyPair?: string;
  orderDealId?: string;
  debitSum?: number;
  creditSum?: number;
}

/**
 * Документ обмена валют для сохранения
 */
export interface CreateCurrencyExchangeRequest {
  /** Тип заявки */
  orderType: "BUY_CURRENCY" | "SELL_CURRENCY" | "CONVERSION_CURRENCY";

  /**
   * ID счёта списания
   * @format uuid
   */
  debitAccountId: string;

  /** Сумма списания */
  debitSum?: number;

  /**
   * ID счёта зачисления
   * @format uuid
   */
  creditAccountId: string;

  /** Сумма зачисления */
  creditSum?: number;

  /** Заполненная пользователем сумма */
  specifiedSum: "DEBIT" | "CREDIT";

  /** Тип курса операции */
  rateType: "BANK" | "INDIVIDUAL";

  /** Курс обмена */
  rate?: number;

  /** Валютная пара */
  pair: string;

  /** Id обмена в дилинге */
  orderDealId?: string;
}

/**
 * ID сохраненного документа обмена валют
 */
export interface CurrencyExchangeSavedResponse {
  /**
   * ID сохраненного документа
   * @format uuid
   */
  id?: string;
}

/**
 * Детальная информация документа обмена валют
 */
export interface CurrencyExchangeDetailResponse {
  /**
   * ID документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  docNum?: string;

  /**
   * Дата документа
   * @format date-time
   */
  docDate?: string;

  /** Ответ от дилинга */
  dealingComment?: string;

  /**
   * Дата отправки документа
   * @format date-time
   */
  clientSentDate?: string;

  /**
   * Дата обработки документа
   * @format date-time
   */
  bankProcessDate?: string;

  /**
   * ID клиента
   * @format uuid
   */
  clientId?: string;

  /** Наименование клиента */
  fullName?: string;

  /** ИНН клиента */
  inn?: string;

  /** КИО клиента */
  kio?: string;

  /** ОКПО клиента */
  okpo?: string;

  /** ОГРН клиента */
  ogrn?: string;

  /** Адрес клиента */
  addressStr?: string;

  /**
   * ID подразделения банка
   * @format uuid
   */
  branchId?: string;

  /** Код подразделения банка */
  branchCode?: string;

  /** Наименование подразделения банка */
  branchName?: string;

  /**
   * ID пользователя клиента
   * @format uuid
   */
  delegateId?: string;

  /** ФИО пользователя клиента */
  fullDelegateName?: string;

  /** Телефон пользователя клиента */
  phone?: string;

  /** Тип заявки */
  orderType?: string;

  /**
   * ID счёта списания
   * @format uuid
   */
  debitAccountId?: string;

  /** Двадцатизначный номер счёта списания */
  debitAccount?: string;

  /** Сумма списания */
  debitSum?: number;

  /** Буквенный код валюты списания */
  debitCurrency?: string;

  /** Название валюты списания */
  debitCurrencyName?: string;

  /** Цифровой код валюты списания */
  debitCurrencyNum?: string;

  /**
   * ID счёта зачисления
   * @format uuid
   */
  creditAccountId?: string;

  /** Двадцатизначный номер счёта зачисления */
  creditAccount?: string;

  /** Сумма зачисления */
  creditSum?: number;

  /** Буквенный код валюты зачисления */
  creditCurrency?: string;

  /** Название валюты зачисления */
  creditCurrencyName?: string;

  /** Цифровой код валюты зачисления */
  creditCurrencyNum?: string;

  /** Заполненная пользователем сумма */
  specifiedSum?: "DEBIT" | "CREDIT";

  /** Курс обмена */
  rate?: string;

  /** Валютная пара */
  pair?: string;

  /** Тип курса операции */
  rateType?: string;

  /** Код валютной операции */
  operationCode?: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата и время изменения статуса
   * @format date-time
   */
  changeStateTime?: string;

  /**
   * Дата и время последнего обновления
   * @format date-time
   */
  lastUpdate?: string;

  /** Причина отказа банком */
  bankRejectReason?: string;

  /** Список возможностей */
  permissions?: ClientPermissions[];
}

/**
 * Права пользователя
 */
export interface GetPermissionUnit {
  /** Название возможности */
  name?: string;

  /** Описание возможности */
  desc?: string;

  /** Признак доступности возможности */
  isAvailable?: boolean;
}

/**
 * Список прав пользователя
 */
export interface PermissionResponse {
  /** Тип документа */
  entityStrId?: string;
  permissions?: GetPermissionUnit[];
}

/**
 * ККБ документа
 */
export interface CcbDocumentDetails {
  /** Поля документа ККБ */
  fields?: CurrencyExchangeCcb;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Поля документа ККБ
 */
export interface CurrencyExchangeCcb {
  /** @format uuid */
  id?: string;
  docNum?: string;

  /** @format date-time */
  docDate?: string;
  clientName?: string;
  inn?: string;
  kio?: string;
  okpo?: string;
  ogrn?: string;
  addressStr?: string;
  branchName?: string;
  fullDelegateName?: string;
  phone?: string;
  orderType?: string;
  debitAccount?: string;
  debitSum?: number;
  debitCurrency?: string;
  creditAccount?: string;
  creditSum?: number;
  creditCurrency?: string;
  rateType?: string;
  rate?: string;
  operationCode?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface DocumentCcbResponse {
  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** ККБ документа */
  document?: CcbDocumentDetails;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Элемент списка счетов клиента
 */
export interface AccountEntryResponse {
  /**
   * ID счета
   * @format uuid
   */
  id?: string;

  /** Двадцатизначный номер счета */
  accountNumber?: string;

  /** Буквенный код валюта счёта */
  currency?: string;

  /** Текущий остаток в валюте счета */
  balance?: number;

  /** Тип счета */
  type?: string;

  /** Признак избранного счета */
  isFavorite?: boolean;
}

/**
 * Список счетов клиента
 */
export interface AccountListResponse {
  accounts?: AccountEntryResponse[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-currency-exchange
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-currency-exchange.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Документ обмена валют
     * @name GetCurrencyExchangeList
     * @summary Получение списка документов обмена валют
     * @request POST:/api/currency-exchange/v1/external
     * @secure
     */
    getCurrencyExchangeList: (
      data: CurrencyExchangeFilter,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyExchangeListResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Запрос курса валют
     * @name GetCurrencyRate
     * @summary Запрос курса валют
     * @request POST:/api/currency-exchange/v1/external/currency-rate
     * @secure
     */
    getCurrencyRate: (
      data: GetCurrencyRateRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetCurrencyRateResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/currency-rate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документ обмена валют
     * @name CreateCurrencyExchange
     * @summary Создание документа обмена валют
     * @request POST:/api/currency-exchange/v1/external/create
     * @secure
     */
    createCurrencyExchange: (
      data: CreateCurrencyExchangeRequest,
      params: RequestParams = {}
    ) =>
      this.request<CurrencyExchangeSavedResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документ обмена валют
     * @name GetCurrencyExchangeDetail
     * @summary Получение детальной информации документа обмена валют
     * @request GET:/api/currency-exchange/v1/external/{id}
     * @secure
     */
    getCurrencyExchangeDetail: (id: string, params: RequestParams = {}) =>
      this.request<CurrencyExchangeDetailResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Документ обмена валют
     * @name PrintCurrencyExchange
     * @summary Получение печатной формы документа обмена валют
     * @request GET:/api/currency-exchange/v1/external/print/{id}
     * @secure
     */
    printCurrencyExchange: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/print/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение прав пользователя на операции с документами
     * @name GetClientPermissions
     * @summary Получение прав пользователя на операции с документами
     * @request GET:/api/currency-exchange/v1/external/permissions/{documentType}
     * @secure
     */
    getClientPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/currency-exchange/v1/external/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (query: { documentId: string }, params: RequestParams = {}) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные подписания
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/currency-exchange/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/currency-exchange/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета клиента
     * @name GetClientAccounts
     * @summary Получение списка счетов клиента
     * @request GET:/api/currency-exchange/v1/external/accounts
     * @secure
     */
    getClientAccounts: (params: RequestParams = {}) =>
      this.request<AccountListResponse, ErrorMessage>({
        path: `/api/currency-exchange/v1/external/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
